module.exports = __webpack_public_path__ + "static/media/backgroundBig.34974018.png";